<template>
  <div class="builder__color-option">
    <div class="builder__color-option-name-and-current-choice">
      <div class="builder__color-option-name">
        {{ option.is_embroidery_grouped ? (option.display_title ? option.display_title : option.title) : 'Color' }}:
      </div>
      <div class="builder__color-option-current-choice">
        {{ chosenLabel }}
      </div>
    </div>
    <div class="builder__color-option-choices">
      <div
        v-for="choice in option.choices"
        class="builder__color-option-choice"
        :class="{ 'builder__color-option-choice--disabled': choice.is_disabled == 1 }"
      >
        <input type="radio"
               class="builder__color-option-choice-input"
               :id="domId(choice.id)"
               :value="choice.id"
               v-model="selection"
               :disabled="choice.is_disabled == 1"
        >
        <label
          :for="domId(choice.id)"
          class="builder__color-option-choice-label"
          :class="{ 'builder__color-option-choice-label--disabled': choice.is_disabled == 1 }"
        >
          <span class="builder__color-option-choice-label-fake-input" :style="{ backgroundColor: '#' + (choice.color_hex ? choice.color_hex : '000') }" ></span>
          <span class="builder__color-option-choice-label-text builder__color-option-choice-label-text--hidden">{{ choice.title }}</span>
        </label>
      </div>
      <div v-if="!option.is_required" class="builder__color-option-choice builder__color-option-choice--none">
        <input type="radio"
               class="builder__color-option-choice-input"
               :id="domId('none')"
               :value="null"
               v-model="selection"
        >
        <label class="builder__color-option-choice-label" :for="domId('none')">
          <span class="builder__color-option-choice-label-fake-input"></span>
          <span class="builder__color-option-choice-label-text">{{ noneLabel }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'builder-option-color',
    props: ['option'],

    methods: {
      domId(suffix) {
        return 'product-step-option-' + this.option.id + '-' + suffix
      },
    },

    computed: {
      chosenLabel() {
        let choice = this.option.choices.filter(c => c.id == this.option.selected_value)
        return (choice.length ? choice[0].title : this.noneLabel);
      },

      noneLabel() {
        return this.option.color_none_label ? this.option.color_none_label : ''
      },

      selection: {
        get() { return this.option.selected_value },
        set(newValue) { this.$emit('input', newValue) },
      },

    },
  }
</script>



// WEBPACK FOOTER //
// Color.vue?61a64517